import type { SelectOption } from "@/components/ui/Select";

export const GENDERS: SelectOption[] = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const MARITAL_STATUSES: SelectOption[] = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
];

export const EMIRATES: SelectOption[] = [
  { value: "abu_dhabi", label: "Abu Dhabi" },
  { value: "dubai", label: "Dubai" },
  { value: "sharjah", label: "Sharjah" },
  { value: "ajman", label: "Ajman" },
  { value: "umm_al_quwain", label: "Umm Al Quwain" },
  { value: "ras_al_khaimah", label: "Ras Al Khaimah" },
  { value: "fujairah", label: "Fujairah" },
];

export const VISA_TYPES: SelectOption[] = [
  { value: "employment", label: "Employment visa" },
  { value: "golden", label: "Golden visa" },
  { value: "green", label: "Green visa" },
  { value: "investor_partner", label: "Investor or partner visa" },
  { value: "family_sponsored", label: "Family sponsored" },
  { value: "freelance", label: "Freelance permit" },
  { value: "gcc_national", label: "GCC national" },
  { value: "other", label: "Other" },
];

export const EDUCATION_LEVELS: SelectOption[] = [
  { value: "high_school", label: "High school" },
  { value: "diploma", label: "Diploma" },
  { value: "bachelor", label: "Bachelor's degree" },
  { value: "master", label: "Master's degree" },
  { value: "doctorate", label: "Doctorate" },
  { value: "other", label: "Other" },
];

export const EMPLOYMENT_STATUSES: SelectOption[] = [
  { value: "probation", label: "Probation" },
  { value: "active", label: "Active" },
  { value: "leave", label: "On leave" },
  { value: "resigned", label: "Resigned" },
  { value: "terminated", label: "Terminated" },
];

/**
 * Nationalities, most common in this workforce first.
 *
 * A UAE exchange house hires largely from the subcontinent, the Levant and the
 * Philippines, so those sit at the top of the list rather than buried under an
 * alphabetical A-to-Z.
 */
export const NATIONALITIES: SelectOption[] = [
  { value: "AE", label: "United Arab Emirates" },
  { value: "IN", label: "India" },
  { value: "PK", label: "Pakistan" },
  { value: "PH", label: "Philippines" },
  { value: "BD", label: "Bangladesh" },
  { value: "LK", label: "Sri Lanka" },
  { value: "NP", label: "Nepal" },
  { value: "EG", label: "Egypt" },
  { value: "JO", label: "Jordan" },
  { value: "SY", label: "Syria" },
  { value: "LB", label: "Lebanon" },
  { value: "PS", label: "Palestine" },
  { value: "SD", label: "Sudan" },
  { value: "YE", label: "Yemen" },
  { value: "IQ", label: "Iraq" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "OM", label: "Oman" },
  { value: "KW", label: "Kuwait" },
  { value: "BH", label: "Bahrain" },
  { value: "QA", label: "Qatar" },
  { value: "MA", label: "Morocco" },
  { value: "TN", label: "Tunisia" },
  { value: "DZ", label: "Algeria" },
  { value: "SO", label: "Somalia" },
  { value: "ET", label: "Ethiopia" },
  { value: "KE", label: "Kenya" },
  { value: "UG", label: "Uganda" },
  { value: "NG", label: "Nigeria" },
  { value: "GH", label: "Ghana" },
  { value: "ZA", label: "South Africa" },
  { value: "ID", label: "Indonesia" },
  { value: "MY", label: "Malaysia" },
  { value: "CN", label: "China" },
  { value: "TR", label: "Turkey" },
  { value: "IR", label: "Iran" },
  { value: "AF", label: "Afghanistan" },
  { value: "GB", label: "United Kingdom" },
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "AU", label: "Australia" },
  { value: "FR", label: "France" },
  { value: "DE", label: "Germany" },
  { value: "RU", label: "Russia" },
  { value: "UA", label: "Ukraine" },
  { value: "OTHER", label: "Other" },
];
